import { useCurrentDate } from "./lib";

export function Banner() {
  const date = useCurrentDate(60 * 1000);
  if (
    date < new Date("2025-11-18T00:00:00-08:00") ||
    date > new Date("2025-11-19T18:00:00-08:00")
  ) {
    return null;
  }
  return (
    <div className="bg-bg-warning text-text-on-warning flex flex-row text-md items-center justify-center w-full py-3 px-4">
      <span className="mr-2">❗️</span>
      <span>the zamboni may be dead this morning (nov 19th)</span>
    </div>
  );
}
